import IndependentCharterSchoolGroup from './IndependentCharterSchoolGroup.page';

export default IndependentCharterSchoolGroup;